<template>
  <div class="login">
    <div class="login_center">
      <el-row :gutter="0" type="flex" justify="space-between">
        <el-col>
          <img class="login_img" src="@/assets/images/login_img.png" alt="" />
        </el-col>
        <el-col>
          <div class="login_right">
            <el-tabs
              class="achtabs"
              v-model="activeName"
              @tab-click="handleClick"
              :stretch="true"
            >
              <el-tab-pane label="登录" name="登录">
                <div class="login_box_b">
                  <el-form
                    class="pass_form pass_form_forget"
                    status-icon
                    ref="passFormName"
                    :hide-required-asterisk="true"
                    label-position="left"
                    :model="passForm"
                    :rules="passRules"
                  >
                    <el-form-item label="手机号" prop="phone">
                      <el-input
                        class="inlineInput"
                        v-model.trim="passForm.phone"
                        placeholder="请输入手机号"
                        @keypress.native.enter="submitFormlogin('passFormName')"
                      ></el-input>
                    </el-form-item>

                    <el-form-item label="密码" prop="password">
                      <el-input
                        show-password
                        class="inlineInput"
                        v-model="passForm.password"
                        placeholder="请输入密码"
                        @keypress.native.enter="submitFormlogin('passFormName')"
                      ></el-input>
                    </el-form-item>

                    <el-form-item>
                      <el-button
                        class="tradebtn"
                        type="primary"
                        @click="submitFormlogin('passFormName')"
                        >立即登录</el-button
                      >
                    <div class="forget_txt"><span class="a_link" @click="dialogVisible = true">忘记密码？</span></div>

                    </el-form-item>

                  </el-form>
                </div>
               
               
              </el-tab-pane>
              <el-tab-pane label="注册" name="注册">
                <div class="login_box_b">
                  <el-form
                    class="pass_form pass_form_forget"
                    status-icon
                    :hide-required-asterisk="true"
                    ref="ruleFormforget"
                    label-position="left"
                    :model="yzmForm"
                    :rules="yzmRules"
                  >
                    <el-form-item label="手机号" prop="phone">
                      <el-input
                        class="inlineInput"
                        v-model.trim="yzmForm.phone"
                        placeholder="请输入手机号"
                        @keypress.native.enter="submitForm('ruleFormforget')"
                      ></el-input>
                    </el-form-item>

                    <el-form-item label="密码" prop="password">
                      <el-input
                        show-password
                        class="inlineInput"
                        v-model="yzmForm.password"
                        placeholder="请输入密码"
                        @keypress.native.enter="submitForm('ruleFormforget')"
                      ></el-input>
                    </el-form-item>

                    <el-form-item label="企业名称" prop="company">
                      <el-input
                        class="inlineInput"
                        v-model="yzmForm.company"
                        placeholder="请输入企业名称"
                        @keypress.native.enter="submitForm('ruleFormforget')"
                      ></el-input>
                    </el-form-item>
                    
                    <el-form-item>
                      <el-button
                        class="tradebtn"
                        type="primary"
                        @click="submitForm('ruleFormforget')"
                        >注册</el-button
                      >
                    </el-form-item>

                      <el-checkbox v-model="checked"></el-checkbox>
                      <span class="checkbox_txt">我已阅读并同意<span class="a_link" @click="openUrl()">《用户协议》</span></span>
                  </el-form>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 忘记密码 -->
    <el-dialog
    title="忘记密码"
    :visible.sync="dialogVisible"
    :destroy-on-close='true'
    width="40%">
    <forget-pass/>
  </el-dialog>

  </div>
</template>

<script>
import  {sesStorage}  from '@/model/storage.js'
import Qs from "qs";
import ForgetPass from '@/components/forgetPass.vue';
export default {
  name: "",
  components: {
    ForgetPass
  },
  data() {
    var phonerule = (rule, value, callback) => {
      const reg = 11 && /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/;
      if (value === "") {
        callback(new Error("请输入注册的手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    return {
      dialogVisible:false,
      disabled: false,
      time: 0,
      btntxt: "重新发送",
      passForm: {
        phone: "",
        // sendcode: "",
        password:""
      },
      yzmForm: {
        phone: "",
        password: "",
        company:''
      },
      checked:true,
      activeName: "登录",
      yzmRules: {
        phone: [
          { required: true, validator: phonerule, trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
        ],
        company: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
      },
      passRules: {
        phone: [
          { required: true, validator: phonerule, trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    openUrl(){
      window.open('./html/zhuce.html')
    },
    handleClick(tab, event) {},
    goforget(){
      this.$router.push({
        path:'/home/Forgetpass'
      })
    },
    submitFormlogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
                this.$http
                  .post("/front/user/login", Qs.stringify(this.passForm))
                  .then((res) => {
                    if (res.data.code == 0) {
                      this.$message({
                        message: res.data.msg,
                        type: "success",
                        center: true,
                      });
                      sesStorage.set('userObj',res.data.data)
                      setTimeout(()=>{
                        if(sesStorage.get('userObj')&&sesStorage.get('userObj').password){
                            this.$router.push({
                              path:'/home/index'
                            })
                        }
                      },100)
                      
                    } else {
                      this.$message({
                        message: res.data.msg,
                        type: "error",
                        center: true,
                      });
                    }
                  })
                  .catch((error) => {});
        } else {
          return false;
        }
      });
    },
    submitForm(formName) {
      if(this.checked){
        this.$refs[formName].validate((valid) => {
        if (valid) {
                this.$http
                  .post("/front/user/register", Qs.stringify(this.yzmForm))
                  .then((res) => {
                    if (res.data.code == 0) {
                      this.$message({
                        message: res.data.msg,
                        type: "success",
                        center: true,
                      });
                      sesStorage.set('userObj',res.data.data)
                      setTimeout(()=>{
                        this.yzmForm = {
                          phone: "",
                          password: "",
                          company:''
                        }
                        this.$router.go(0)
                      },100)
                    } else {
                      this.$message({
                        message: res.data.msg,
                        type: "error",
                        center: true,
                      });
                    }
                  })
                  .catch((error) => {});
        } else {
          return false;
        }
      });
      }else{
        this.$message({
          message: "请阅读并同意《用户协议》",
          type: "error",
          center: true,
        });
      }
    },

    //手机验证发送验证码
    sendcode() {
      const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
      if (this.yzmForm.phone == "") {
        this.$message.error("手机号不能为空");
        return;
      }
      if (!reg.test(this.yzmForm.phone)) {
        this.$message.error("请输入正确的手机号");
        return;
      } else {
        let data = {
          phone: this.yzmForm.phone,
        };
        this.$http
          .post("/front/user/yanzhengma", Qs.stringify(data))
          .then((res) => {
            if (res.data.code == 0) {
              this.$message({
                message: res.data.msg,
                type: "success",
                center: true,
              });
              this.time = 60;
              this.disabled = true;
              this.timer();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
                center: true,
              });
            }
          })
          .catch((error) => {});
      }
    },
    //60S倒计时
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + "s后重新获取";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        this.disabled = false;
      }
    },
  },
  mounted() {
    
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.login {
  .a_link{
    color: #FF9F54;
    cursor: pointer;
  }
  width: 100%;
  height: 700px;
  background: url('../assets/images/login_bg.png') center center no-repeat ;
  background-size: cover;
  overflow: hidden;
  .login_center {
    width: 1239px;
    margin: 104px auto 0 auto;
  }
  .login_img{
    margin-top: 46px;
  }
  .login_right {
    background: #ffffff;
    width: 500px;
    float: right;
    position: relative;

    .line_s{
      width: 1px;
      height: 50px;
      position:absolute;
      left: 50%;
      background-color: #f2f2f2;
      top: 10px;
    }
    
    .achtabs {
      & >>>.el-tabs__nav-wrap::after{
        background-color: #CCCCCC;
        height: 2px!important;
      }
      & >>>.el-tabs__nav-wrap{
      }
      & >>> .el-tabs__header {
        margin: 0 0 5px;
      }
      & >>> .el-tabs__nav-wrap::after {
        height: 1px;
      }
      & >>> .el-tabs__content {
        overflow: initial;
      }
    
    }

    & >>> .el-tabs__item {
      padding: 0;
      color: #808080;
      height: 90px;
      line-height: 90px;
      font-size: 18px;
      border: none;
    }
    & >>> .el-tabs__active-bar {
      background-color: #303643
    }
    & >>> .el-tabs__item.is-active {
      color: #303643;
      font-weight: bold;
      border: none;
    }
  }

  .pass_form {
    padding: 20px 79px 0 79px;
    & >>> .el-form-item{
      position: relative;
    }
    & >>> .el-form-item__label {
      color: #303643;
      position: absolute;
      left: 16px;
      width: 90px;
      z-index: 2;
    }
    .tradebtn {
      height: 42px;
      background: #303643;
      border-radius: 2px;
      color: #fff;
      border:none;
      width: 100%;
    }
  }
  
  .inlineInput {
    &>>>.el-input__inner{
      background: #f9fafe;
      border: 1px solid #303643;
      border-radius: 2px;
      padding-left: 90px;
    }
  }
  .inlineInput_s {
    width: 184px;
    &>>>.el-input__inner{
      border-radius: 0;
    }
  }
  .inlinebtn {
    width: 108px;
    padding: 12px 0;
     border-radius: 0;
    float: right;
    color: #999999;
    &.el-button:active {
      color: #19539a;
      border-color: #19539a;
      outline: 0;
    }
    &.el-button:focus,
    &.el-button:hover {
      color: #19539a;
      border-color: #19539a;
      background-color: #ecf5ff;
    }
  }

  .inlinetx {
    display: inline-block;
    width: 106px;
    height: 38px;
    border: 1px solid #333;
    float: right;
  }

  .login_down_box{
    color: #808080;
    padding: 0 48px;
    font-size: 14px;
    span{
      color: #85501C;
      font-weight: bold;
      cursor: pointer;
    }
    .forget{
      cursor: pointer;
    }
  }

  .login_down_box_s{
    padding: 50px 48px 20px 48px;
    font-size: 14px;
    color: #CCCCCC;
    text-align: center;
  }
  .login_box_b{
    padding: 60px 0 120px 0;
  }
  .checkbox_txt{
    font-size: 14px;
  }
  .forget_txt{
    font-size: 14px;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue